// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import * as Sentry from "@sentry/vue"
import { Integrations } from "@sentry/tracing"
import 'core-js/features/promise'
import 'core-js/features/array/find'
import 'core-js/features/array/find-index'
import 'core-js/features/string/includes'
import 'core-js/features/object/assign'
import 'core-js/features/symbol'
import 'regenerator-runtime/runtime'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import axios from 'axios'
import { syncActingCommitteeHeader } from '@/services/actingCommittee'
import App from './App'
import router from './router'
import store from './store'
import './filters'
import useUserRole from './composables/useUserRole'

Vue.use(VueCompositionApi)

Object.defineProperties(Vue.prototype, {
  $role: { get: () => useUserRole().role },
  $isUser: { get: () => useUserRole().isUser },
  $isVolunteer: { get: () => useUserRole().isVolunteer },
  $isSecretary: { get: () => useUserRole().isSecretary },
  $isSecretaryMember: { get: () => useUserRole().isSecretaryMember },
  $isAdmin: { get: () => useUserRole().isAdmin },
  $isSuperAdmin: { get: () => useUserRole().isSuperAdmin },
  $isSecretaryOrAdmin: { get: () => useUserRole().isSecretaryOrAdmin },
  $isSuperSecretary: { get: () => useUserRole().isSuperSecretary },
  $isActingForOtherCommittee: { get: () => useUserRole().isActingForOtherCommittee }
})

const token = localStorage.getItem('bearer')
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

syncActingCommitteeHeader()

/* Eslint doesn't like ga not being defined but it seems to work? */
// eslint-disable-next-line
ga('set', 'page', router.currentRoute.path)
// eslint-disable-next-line
ga('send', 'pageview')

router.afterEach((to) => {
  // eslint-disable-next-line
  ga('set', 'page', to.path)
  // eslint-disable-next-line
  ga('send', 'pageview')
})

if (Vue.prototype.$sentry?.dsn) {
  Sentry.init({
    Vue,
    dsn: `${Vue.prototype.$sentry.dsn}`,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [`${Vue.prototype.$api}`, /^\//]
      })
    ],
    environment: `${Vue.prototype.$sentry.environment}`,
    disablePerformance: true,
    // Benign browser warning, not an app error: fires when a ResizeObserver callback
    // triggers another resize within the same frame (e.g. ResponsiveTable's own
    // ResizeObserver reacting to a layout change it just caused). The browser just
    // defers the notification to the next frame — nothing is broken or undelivered
    // for good. Wording differs by engine, hence both variants.
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications.',
      'ResizeObserver loop limit exceeded'
    ]
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js